import { useQuery } from '@apollo/client/react/hooks';
import { gql } from '@yi/core';

export const LAST_SAVED_POSITION_NONEXIST = -1;
/**
 * hook returns the current user position of media if it exists, or -1 otherwise
 */
export function useGetCurrentUserMediaPosition(
  contentId: string,
  contentType: gql.typesClient.MediaPositionContentType,
): number {
  const { data } = useQuery<
    gql.typesClient.Query_CurrentUserMediaPosition,
    gql.typesClient.Query_CurrentUserMediaPositionVariables
  >(gql.Query_CurrentUserMediaPosition, {
    variables: {
      content_id: contentId,
      content_type: contentType,
    },
    fetchPolicy: 'network-only',
  });

  return data?.CurrentUserMediaPosition?.position_in_seconds ?? LAST_SAVED_POSITION_NONEXIST;
}
